import depth from '@workday/canvas-depth-web';
export default depth;
